export const SESSION_TIMEOUT_DAYS = ['0', '1', '7', '14', '30'];
export const SESSION_TIMEOUT_HOURS = ['1', '2', '4', '8', '12'];
export const SESSION_TIMEOUT_MINUTES = ['0', '15', '30', '45'];

const subdomainPostfix = process.env.REACT_APP_SUBDOMAIN_POSTFIX ?? '.machadalo.com';

export const SUBDOMAIN_DISPLAY_POSTFIX =
  subdomainPostfix.replace(/:\d+$/, '') || subdomainPostfix;

export function buildSubdomainPreviewUrl(subdomain, postfix = SUBDOMAIN_DISPLAY_POSTFIX) {
  const trimmed = subdomain?.trim();
  return trimmed ? `https://${trimmed}${postfix}` : `https://your-org${postfix}`;
}

export function sanitizeSubdomainInput(value) {
  return value.toLowerCase().replace(/[^a-z0-9-]/g, '');
}

export function sanitizeMobileInput(value) {
  return value.replace(/\D/g, '').slice(0, 15);
}
